import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CartList } from "../views/CartController/CartList";

interface CartState {
    rowsPerPage: number;
    selectedCart: CartList | null;
}

const initialState: CartState = {
    rowsPerPage: 10,
    selectedCart: null,
};

export interface LocationPoint {
  lat: number;
  lng: number;
}

export interface DeliverySession {
  createdAt: string;
  deliveryDistance: number;
  deliveryEndIndex: number;
  deliveryEndTime: string;
  deliveryStartIndex: number;
  deliveryStartTime: string;
  groupOrderId: string;
  id: string;
  isActive: boolean;
  locationPoints: LocationPoint[];
  sessionEndPoint: LocationPoint;
  sessionEndTime: string;
  sessionStartPoint: LocationPoint;
  sessionStartTime: string;
  totalDistance: number;
}

export interface CartInfo {
  cartId: string;
  cartPersonId: string;
  userId: string;
}

export interface RouteStop {
  location: LocationPoint;
  orderId: string;
}

export interface DeliveryRoute {
  distanceInKm: number;
  route: RouteStop[];
  totalDuration: string;
  hubLocation: LocationPoint;
}

export interface Order {
  orderId: string;
  orderStatus: string;
}

export interface GroupOrder {
  cart: CartInfo;
  createdAt: string;
  deliveryRoute: DeliveryRoute;
  orders: Order[];
  restaurantId: string;
  status: string;
}

export interface StatusStyle {
  bg: string;
  text: string;
  border: string;
}

export interface GroupOrderMap {
  [key: string]: GroupOrder;
}

export const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        setRowsPerPage(state, action: PayloadAction<number>) {
            state.rowsPerPage = action.payload;
        },
        clearRowsPerPage(state) {
            state.rowsPerPage = 10;
        },
        // Add these new reducers for selected cart
        setSelectedCart(state, action: PayloadAction<CartList | null>) {
            state.selectedCart = action.payload;
        },
        clearSelectedCart(state) {
            state.selectedCart = null;
        }
    }
})

export const { 
    setRowsPerPage, 
    clearRowsPerPage,
    setSelectedCart,
    clearSelectedCart 
} = cartSlice.actions;

export default cartSlice.reducer;